// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';

export const resetProductDetails = () => ({
    type: actions.RESET_CLAIM_INCENTIVE_PRODUCT_DETAILS
});



// WEBPACK FOOTER //
// ./src/claim/incentive/action-creators/reset-product-details.js